<h2 #numberCounter class="m-0">{{digit}}</h2>
